import Inverter from "./devices/Inverter";
import SolarPlant from "./SolarPlant";
import globalFunctions from "../functions/globalFunctions"

class SolarFunctions {

    getSolarPlant() {

    };

   
    combine(inverters, acVoltage, phases) {
        // console.log("combine>" + JSON.stringify(inverters.length) );
        var combination = { acVoltage: acVoltage, phases: phases, inverters: [], acPower: 0, nInverters: 0, price: 0, cost: 0 };
        //console.log("combine>" + JSON.stringify(combination) );

        var a = 0;
        while (a < inverters.length) {

            var inverter = new Inverter();
            inverter = Object.assign(inverter,inverters[a])

            inverter.quantity = 1;

            var found = false;

            for (var b = 0; b < combination.inverters.length; b++) {
                if (inverter.code == combination.inverters[b].code) {
                    combination.inverters[b].quantity += inverter.quantity;
                    combination.acPower += inverter.acPower;
                    combination.nInverters += inverter.quantity;
                    //  combination.price += inverter.price;
                    // combination.cost += inverter.cost;
                    found = true;
                }
            }
            if (found == false) {
                combination.inverters.push(inverter);
                combination.acPower += inverter.acPower;
                combination.nInverters += inverter.quantity;
                // combination.price += inverter.price;
                // combination.cost += inverter.cost;

            }

            a++;
        }

        //console.log("combine2" + JSON.stringify(combination) );

        return combination;

    };
    concatMppts(combination, modulo, nModulos) {
        console.log("%c concatMppts", "color:green");
        var mppts = [];
        var nMax = 0;
        var nMin = 0;
        var inverter = {};
        var indexinverter = 0;

        for (var i = 0; i < combination.inverters.length; i++) {
            inverter = combination.inverters[i];
            inverter.addDcWiring();
            // console.log("inverter:" + JSON.stringify(inverter));

            for (var i = 0; i < inverter.mppts.length; i++) {
                var mppt = [];
                //numberOfStrings
                //nModulesRequestPerString.max 
                for (var s = 1; s <= inverter.dcWiring.mppts[i].limits.sMax; s++) {
                    for (var m = inverter.dcWiring.mppts[i].limits.mMin; m <= inverter.dcWiring.mppts[i].limits.mMax; m++) {
                        //s = strings
                        //m = modules on string
                        mppt.push({ n: s * m, s: s, m: m, inverter: inverter.code, indexMppt: i })
                    }
                }

                nMax += inverter.dcWiring.mppts[i].limits.mMax * inverter.dcWiring.mppts[i].limits.sMax * inverter.quantity;

                for (var q = 0; q < inverter.quantity; q++) {
                    var newMppt = [];
                    for (var a = 0; a < mppt.length; a++) {
                        var m0 = Object.assign({}, mppt[a]);
                        m0.indexinverter = q;
                        m0.indexList = i;
                        newMppt.push(m0);
                    }
                    mppts.push(newMppt);
                }
            }
        }

        return { mppts: mppts, nMax: nMax, acPower: combination.acPower, combination: combination };

        if (nModulos <= nMax)
            return { mppts: mppts, nMax: nMax, acPower: combination.acPower, combination: combination };
        else
            return null;


    };
    generatorEstimation(dcPower, generators) {
        var dcPowerArr = [0];
        var costArr = [0];
        for (var g = 0; g < generators.length; g++) {
            var generator = generators[g];
            dcPowerArr.push(generator.dcPower);
            costArr.push(generator.product.cost);
        }
        var found = false;
        var a = dcPowerArr.length - 1;
        var foundIndex = -1;
        while ((!found) && (a >= 0)) {
            if (dcPower > dcPowerArr[a]) {
                foundIndex = a;
                found = true;
            }
            a--;
        };
        if (foundIndex >= (dcPowerArr.length - 1))
            foundIndex = dcPowerArr.length - 2;
        var a = (costArr[foundIndex + 1] - costArr[foundIndex]) / (dcPowerArr[foundIndex + 1] - dcPowerArr[foundIndex]);
        var b = costArr[foundIndex] - (a * dcPowerArr[foundIndex]);
        var cost = dcPower * a + b;
        return cost
    };


    //Inverters must be sorted by acPower
    getSolarPlantsWithGenerators(dcPower, generators, acVoltage, phases, estimated, module) {
        // alert(dcPower);

        if (generators.length == 0)
            return [];

        //var acVoltage = acVoltage;
        // var phases = 3;
        var acPower = dcPower / 2;
        var p = acPower;
        var a = 0;
        var b = 0;
        var c = 0;
        var d = 0;

        var comb = {};
        var solarPlants = [];
        var maxDcPower = dcPower * 2;

        //alert(JSON.stringify(estimated));
        // alert(JSON.stringify(globalFunctions))

        //Custom kit == true then user modules and inverters, otherwise use standard generators

        //Should I combine 2 or more kits?
        //Yes
        generators.sort(function (a, b) { return a.dcPower - b.dcPower });
        //
        if (module){
            generators[0].modules[0] = module;
        }
        //alert(JSON.stringify( generators[0].modules[0]))
            
        var dcPowerModule = generators[0].modules[0].dcPower;

        //alert(JSON.stringify(dcPowerModule))
        //alert(dcPowerModule)


        var generator;
        if (!estimated) {
            generator = generators.find(element => element.dcPower >= dcPower);
        }
        else {
            var nModules = Math.ceil(dcPower / dcPowerModule)
            var dcPowerEstimated = nModules * dcPowerModule;

            
            var cost = this.generatorEstimation(dcPowerEstimated, generators);
            //alert(JSON.stringify(cost));
            generator =generators[0];
            generator.modules[0].quantity = nModules;

            
            //alert(JSON.stringify(generator));
            //alert(dcPowerEstimated)
            generator.dcPower = dcPowerEstimated;
            generator.product.cost = cost;
            generator.code = `KIT-${globalFunctions.formatDecimal(generator.dcPower)}-KWP`
            generator.description = `Kit fotovoltaico ${globalFunctions.formatDecimal(generator.dcPower)} kWp.`

        }

      

        if (generator) {
            var s = new SolarPlant([], acVoltage, phases, {}, [generator])
            s.availableDevices.generators = generators;
            //Find bigger than
            solarPlants.push(s);

            return solarPlants;

        } else {
            return [];
        }





        if (inverters.length == 0) {
            console.log("getSolarPlants: inverters ==0");
            return [];
        }
        if (dcPower < inverters[0].dcMinPower) {
            acPower = inverters[0].acPower;
            inverters[0].addDcWiring(module);
            dcPower = inverters[0].dcMinPower;// * module.dcPower; 
            //      maxDcPower = acPower*2;
        }
        for (a = 0; a < inverters.length; a++) {
            var s = new SolarPlant([inverters[a]], acVoltage, phases, module)
            if ((dcPower >= s.dcMinPower) && (dcPower <= s.dcMaxPower)) {
                solarPlants.push(s);
            }

            for (b = 0; b < inverters.length; b++) {
                var s = new SolarPlant([inverters[a], inverters[b]], acVoltage, phases, module)
                if ((dcPower >= s.dcMinPower) && (dcPower <= s.dcMaxPower)) {
                    solarPlants.push(s)
                };


                for (c = 0; c < inverters.length; c++) {
                    var s = new SolarPlant([inverters[a], inverters[b], inverters[c]], acVoltage, phases, module)
                    if ((dcPower >= s.dcMinPower) && (dcPower <= s.dcMaxPower))
                        solarPlants.push(s);
                }



            }
        }
        console.log("solar plants number found:" + solarPlants.length)
        //console.log("solar plants number mppts found:" + solarPlants[0].mppts.length)

        //console.log(JSON.stringify("solarPlants"))
        //console.log(JSON.stringify({solarPlants}))

        solarPlants.sort(function (a, b) { return a.acPower - b.acPower });

        solarPlants.sort(function (a, b) { return a.nInverters - b.nInverters });

        //console.log("end sortings")

        if (solarPlants.length == 0) {
            //get simple combination   
            return this.getSimpleSolarPlant(dcPower, inverters, module, acVoltage, phases);

        }

        //If there is no solarPlant create a simple comination and re
        var concats = [];
        //Search solarPlant that is able to use that quantity
        var nModulesRequest = Math.ceil(dcPower / module.dcPower);
        for (a = 0; a < solarPlants.length; a++) {
            solarPlants[a].calc(module);

            if (solarPlants[a].mppts.length >= 10) {
                return this.getSimpleSolarPlant(dcPower, inverters, module, acVoltage, phases);
            }

            var config;
            if (solarPlants[a].nMax >= nModulesRequest) {
                console.log("Found:" + solarPlants[a].nMax)
                //Check the first configuration for that solar plant 
                solarPlants[a].calcConfig(nModulesRequest);
                console.log("%c -------getConfigs config" + JSON.stringify(solarPlants[a].config), 'color: green');
                return [solarPlants[a]];
            }
        }

        return [];


    };
    //Inverters must be sorted by acPower
    getSolarPlants(dcPower, inverters, module, acVoltage, phases, customKit) {
        //Custom kit == true then user modules and inverters, otherwise use standard generators
        //var acVoltage = acVoltage;
        // var phases = 3;
        var acPower = dcPower / 2;
        var p = acPower;
        var a = 0;
        var b = 0;
        var c = 0;
        var d = 0;

        var comb = {};
        var solarPlants = [];
        var maxDcPower = dcPower * 2;

        if (inverters.length == 0) {
            console.log("getSolarPlants: inverters ==0");
            return [];
        }
        if (dcPower < inverters[0].dcMinPower) {
            acPower = inverters[0].acPower;
            inverters[0].addDcWiring(module);
            dcPower = inverters[0].dcMinPower;// * module.dcPower; 
            //      maxDcPower = acPower*2;
        }
        for (a = 0; a < inverters.length; a++) {
            var s = new SolarPlant([inverters[a]], acVoltage, phases, module)
            if ((dcPower >= s.dcMinPower) && (dcPower <= s.dcMaxPower)) {
                solarPlants.push(s);
            }

            for (b = 0; b < inverters.length; b++) {
                var s = new SolarPlant([inverters[a], inverters[b]], acVoltage, phases, module)
                if ((dcPower >= s.dcMinPower) && (dcPower <= s.dcMaxPower)) {
                    solarPlants.push(s)
                };


                for (c = 0; c < inverters.length; c++) {
                    var s = new SolarPlant([inverters[a], inverters[b], inverters[c]], acVoltage, phases, module)
                    if ((dcPower >= s.dcMinPower) && (dcPower <= s.dcMaxPower))
                        solarPlants.push(s);
                }



            }
        }
        console.log("solar plants number found:" + solarPlants.length)
        //console.log("solar plants number mppts found:" + solarPlants[0].mppts.length)

        //console.log(JSON.stringify("solarPlants"))
        //console.log(JSON.stringify({solarPlants}))

        solarPlants.sort(function (a, b) { return a.acPower - b.acPower });

        solarPlants.sort(function (a, b) { return a.nInverters - b.nInverters });

        //console.log("end sortings")

        if (solarPlants.length == 0) {
            //get simple combination   
            return this.getSimpleSolarPlant(dcPower, inverters, module, acVoltage, phases);

        }

        //If there is no solarPlant create a simple comination and re
        var concats = [];
        //Search solarPlant that is able to use that quantity
        var nModulesRequest = Math.ceil(dcPower / module.dcPower);
        for (a = 0; a < solarPlants.length; a++) {
            solarPlants[a].calc(module);

            if (solarPlants[a].mppts.length >= 10) {
                return this.getSimpleSolarPlant(dcPower, inverters, module, acVoltage, phases);
            }

            var config;
            if (solarPlants[a].nMax >= nModulesRequest) {
                console.log("Found:" + solarPlants[a].nMax)
                //Check the first configuration for that solar plant 
                solarPlants[a].calcConfig(nModulesRequest);
                console.log("%c -------getConfigs config" + JSON.stringify(solarPlants[a].config), 'color: green');
                return [solarPlants[a]];
            }
        }

        return [];


    };
    getSimpleSolarPlant(dcPower, inverters, module, acVoltage, phases) {
        console.log("getSimpleSolarPlant")
        var acPower = 0.77 * dcPower;
        var p = dcPower;
        console.log({ dcPower })
        inverters.sort(function (a, b) { return b.acPower - a.acPower });

        var a = 0;
        var s = new SolarPlant([], acVoltage, phases, module);
        var listInverters = [];
        var inverter;
        while ((p >= 0) && (a < inverters.length)) {
            inverter = inverters[a]
            var quantity = Math.floor(p / inverter.dcMaxPower);
            if (quantity > 0) {
                inverter.quantity = quantity;
                s.addInverter(inverter);
                p -= inverter.dcMaxPower * inverter.quantity;
            }
            a++;
        };

        if ((p > 0) && (inverters.length > 0)) {
            inverter = inverters[inverters.length - 1];
            inverter.quantity = 1;
            s.addInverter(inverter);
        }
        s.calc(module);
        var nModulesRequest = Math.ceil(dcPower / module.dcPower);
        s.nModules = nModulesRequest;
        s.dcPower = Math.round(nModulesRequest * module.dcPower * 100) / 100;
        s.modules[0].quantity = s.nModules;

        return [s];

    }




}

export default SolarFunctions;